export default __webpack_public_path__ + "static/media/Grocey.aa4dd711.png";